import { Link } from "wouter";
import { Facebook, Instagram, Linkedin } from "lucide-react";

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = {
    Services: [
      { label: "Bathroom Renovations", href: "/#services" },
      { label: "Kitchen Remodeling", href: "/#services" },
      { label: "Whole-Home Renovations", href: "/#services" },
      { label: "24/7 Handyman & Emergency Repair", href: "/#services" },
      { label: "Custom Woodwork", href: "/#services" },
      { label: "Property Maintenance Plans", href: "/#services" },
    ],
    Company: [
      { label: "About Us", href: "/#about" },
      { label: "Portfolio", href: "/#portfolio" },
      { label: "Contact", href: "/#contact" },
    ],
    "Service Area": [
      { label: "Houston, TX", href: "/#contact" },
      { label: "Katy", href: "/#contact" },
      { label: "Sugar Land", href: "/#contact" },
      { label: "Cypress", href: "/#contact" },
      { label: "The Woodlands", href: "/#contact" },
    ],
  };

  const socialLinks = [
    { icon: Facebook, href: "https://www.facebook.com/profile.php?id=61584316090150", label: "Facebook" },
    { icon: Instagram, href: "#", label: "Instagram" },
    { icon: Linkedin, href: "#", label: "LinkedIn" },
  ];

  const handleLinkClick = (href: string) => {
    if (href.startsWith("/#")) {
      const element = document.getElementById(href.substring(2));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <footer className="bg-card border-t" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          <div>
            <h3 className="text-2xl font-heading font-bold mb-4" data-testid="text-footer-brand">
              HHS Build
            </h3>
            <p className="text-muted-foreground mb-4 leading-relaxed">
              Professional construction and renovation services. Transforming spaces with quality craftsmanship.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social, index) => {
                const Icon = social.icon;
                return (
                  <a
                    key={index}
                    href={social.href}
                    target={social.href !== "#" ? "_blank" : undefined}
                    rel={social.href !== "#" ? "noopener noreferrer" : undefined}
                    className="bg-muted w-10 h-10 rounded-md flex items-center justify-center hover-elevate active-elevate-2 transition-all"
                    aria-label={social.label}
                    onClick={social.href === "#" ? (e) => {
                      e.preventDefault();
                      console.log(`${social.label} clicked`);
                    } : undefined}
                    data-testid={`link-social-${social.label.toLowerCase()}`}
                  >
                    <Icon className="h-5 w-5" />
                  </a>
                );
              })}
            </div>
          </div>

          {Object.entries(footerLinks).map(([category, links]) => (
            <div key={category}>
              <h4 className="font-heading font-semibold mb-4" data-testid={`text-footer-${category.toLowerCase()}`}>
                {category}
              </h4>
              <ul className="space-y-2">
                {links.map((link, index) => (
                  <li key={index}>
                    <a
                      href={link.href}
                      onClick={(e) => {
                        e.preventDefault();
                        handleLinkClick(link.href);
                      }}
                      className="text-muted-foreground hover:text-foreground transition-colors"
                      data-testid={`link-footer-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div>
            <h4 className="font-heading font-semibold mb-4" data-testid="text-footer-contact">
              Contact
            </h4>
            <ul className="space-y-2 text-muted-foreground">
              <li data-testid="text-footer-phone">
                <a href="tel:8329989595" className="hover:text-foreground transition-colors">
                  (832) 998-9595
                </a>
              </li>
              <li data-testid="text-footer-email">
                <a href="mailto:info@hhsbuild.com" className="hover:text-foreground transition-colors">
                  info@hhsbuild.com
                </a>
              </li>
              <li data-testid="text-footer-hours">Mon-Fri: 8AM-6PM</li>
              <li className="text-[#ffd700] font-semibold" data-testid="text-footer-emergency">24/7 Emergency Service</li>
              <li data-testid="text-footer-location">Greater Houston Area</li>
            </ul>
          </div>
        </div>

        <div className="border-t pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-muted-foreground" data-testid="text-footer-copyright">
              © {currentYear} HHS Build. All rights reserved.
            </p>
            <div className="flex gap-6 text-sm">
              <Link 
                href="/admin"
                className="text-muted-foreground hover:text-foreground transition-colors"
                data-testid="link-footer-admin"
              >
                Admin
              </Link>
              <a
                href="#"
                className="text-muted-foreground hover:text-foreground transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  console.log("Privacy Policy clicked");
                }}
                data-testid="link-footer-privacy"
              >
                Privacy Policy
              </a>
              <a
                href="#"
                className="text-muted-foreground hover:text-foreground transition-colors"
                onClick={(e) => {
                  e.preventDefault();
                  console.log("Terms of Service clicked");
                }}
                data-testid="link-footer-terms"
              >
                Terms of Service
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
